<style scoped>
.catalog-download-error-snackbar ::v-deep .v-snack__action {
    margin: 0 4px 0 12px;
    align-self: flex-start;
}
.catalog-download-error-snackbar .catalog-download-error-close {
    min-width: 28px !important;
    width: 28px;
    height: 28px;
    padding: 0;
}
.catalog-download-error-snackbar .catalog-download-error-close .v-icon {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.65) !important;
}

.catalog-archive-snackbar ::v-deep .v-snack__action {
    margin: 0 4px 0 12px;
    align-self: flex-start;
}
.catalog-archive-snackbar .catalog-archive-snackbar-close {
    min-width: 28px !important;
    width: 28px;
    height: 28px;
    padding: 0;
}
.catalog-archive-snackbar .catalog-archive-snackbar-close .v-icon {
    font-size: 18px;
    color: rgba(0, 0, 0, 0.65) !important;
}
.catalog-archive-snackbar--below-error {
    margin-top: 56px !important;
}
</style>

<template>
<div>
<v-card elevation="0" class="mb-15">
    <v-container style="max-width: 1680px;" class="container-side-padding">
    <v-row class="ma-0 pa-0 container-side-padding mt-5 mt-sm-10">
        <v-breadcrumbs class="pa-0 diia-nav-breadcrumbs" :items="breadcrumbs_navigation_items">
            <template v-slot:divider>
            <span color="black">|</span>
            </template>
        </v-breadcrumbs>
    </v-row>
    <v-row class="mt-xs-2 mt-md-7">
        <v-col cols="12" md="8" order="3" order-sm="3" order-md="1">

            <h3 class="diia-h3-header" v-if="show_detail_org" ref="detail_info">Загальна інформація про організацію</h3>
            <h3 class="diia-h3-header" v-if="show_detail_irs" ref="detail_info">Загальна інформація про е-ресурс</h3>
            <h3 class="diia-h3-header" v-if="show_detail_sub" ref="detail_info">Загальна інформація про підсистему</h3>
            <h3 class="diia-h3-header" v-if="show_detail_intf" ref="detail_info">Загальна інформація про програмний інтерфейс е-ресурсу</h3>
            <h3 class="diia-h3-header" v-if="show_detail_srv" ref="detail_info">Загальна інформація про сервіс</h3>
            <h3 class="diia-h3-header" v-if="show_detail_itr" ref="detail_info">Загальна інформація про взаємодію</h3>
            <h3 class="diia-h3-header" v-if="show_detail_server" ref="detail_info">Загальна інформація про шлюз безпечного обміну</h3>
            <span class="diia-nav-breadcrumbs" style="opacity: 0.7;">{{ this.$config.query_params.env == 'SEVDEIR' ? 'Промислове середовище' : 'Тестове середовище' }}</span>

            <div v-if="show_detail_org || show_detail_irs || show_detail_intf || show_detail_itr" style="display: flex; align-items: center; margin-top: 24px;">
                <template v-if="show_detail_org">
                    <v-btn v-if="authData && freshTokenRetrievalTransactionCompleted" class="btn_outlined_diia small mr-4" @click="subscribeToObject">
                        <template v-if="!subscribed">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1143_3182)">
                                <path d="M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968L16.2469 18.345L15.2979 13.572L18.8709 10.267L14.0379 9.694L11.9999 5.275L9.96191 9.695L5.12891 10.267L8.70191 13.572L7.75291 18.345L11.9999 15.968V15.968Z" fill="black"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1143_3182">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <span style="margin-left: 8px;">Слідкувати</span>
                        </template>
                        <template v-if="subscribed">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_1143_3187)">
                                <path d="M11.9999 18.26L4.94691 22.208L6.52191 14.28L0.586914 8.792L8.61391 7.84L11.9999 0.5L15.3859 7.84L23.4129 8.792L17.4779 14.28L19.0529 22.208L11.9999 18.26ZM11.9999 15.968V12.5L15.2979 13.572L11.5 12.5L14.0379 9.694L13.5 12L12.5 13.5H12L8.70191 13.572L11.9999 11.5V15.968Z" fill="black"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_1143_3187">
                                <rect width="24" height="24" fill="white"/>
                                </clipPath>
                                </defs>
                            </svg>
                            <span style="margin-left: 8px;">Відстежується</span>
                        </template>
                    </v-btn>
                    <v-btn class="btn_outlined_diia small mr-4" @click="onClickAnalytics">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 18H21V4H3V18H9M15 18L16 21.5M15 18H9M9 18L8 21.5M8 13V14M12 8V14M16 11V14" stroke="black" stroke-width="2" stroke-linecap="square"/>
                        </svg>
                        <span style="margin-left: 8px;" >Аналітика</span>
                    </v-btn>
                </template>
                <template v-if="show_detail_org || show_detail_irs || show_detail_intf || show_detail_itr">
                    <v-btn class="btn_outlined_diia small" @click="switchEnv">
                        <v-icon>mdi-swap-horizontal</v-icon>
                        <span style="margin-left: 8px;" >Змінити середовище</span>
                    </v-btn>
                </template>
            </div>


            <v-data-table
                dense
                :key="detail_data_table_key"
                locale="uk-UA"
                :headers="detail_headers"
                :items="detail_data"
                disable-pagination
                disable-sort
                disable-filtering
                hide-default-footer
                hide-default-header
                :loading="detail_loading"
                @click:row="onClickDetailItem"
                mobile-breakpoint="1"
                class="elevation-0 pa-0 data-table-detail-design fifty-table mt-10"
            >
                <template v-slot:item.value="{ item }">
                    <a v-if="item.type == 'link'" v-bind:href="item.value" target="_blank" class="view-href-a">Переглянути</a>
                    <a v-else-if="item.type == 'file' && item.auth_required && !authData" v-bind:href="$config.cabinet_auth_url" class="view-href-a">Необхідна авторизація</a>
                    <a v-else-if="item.type == 'file'" href="#" @click.prevent="downloadFile(item.value, item.auth_required, item.code)" :style="isFileDownloading(item.value, item.code) ? 'pointer-events: none; opacity: 0.7;' : ''" class="view-href-a">{{ isFileDownloading(item.value, item.code) ? 'Завантаження...' : 'Завантажити' }}</a>
                    <span v-else-if="item.type == 'boolean' && item.value == true">Так</span>
                    <span v-else-if="item.type == 'boolean' && item.value == false">Ні</span>
                    <v-progress-circular v-else-if="item.type == 'loader'" indeterminate size="28" style="opacity: 0.6;"></v-progress-circular>
                    <!-- <a v-if="item.fat == 'Завантажити'" href="https://directory-test.trembita.gov.ua/api/wsdl/SEVDEIR-TEST/GOV/38068238/62_LymanRTG_prod/InfMsgReceiver" target="_blank" class="view-href-a">Завантажити</a> -->
                    <span v-else> 
                        <span v-if="item.auth_required && !authData" style="text-transform: uppercase; font-weight: bold;">Необхідна авторизація</span>
                        <span v-else>{{ item.value }}</span> 
                    </span>
                </template>

                <template v-slot:item.field="{ item }">
                    <span> {{ item.field }}
                        <v-icon style="font-size: 18px; color: black" v-if="item.auth_required && !freshTokenRetrievalTransactionCompleted">mdi-lock</v-icon>
                        <v-icon style="font-size: 18px; color: black" v-if="item.auth_required && freshTokenRetrievalTransactionCompleted && !authData">mdi-lock</v-icon>
                        <v-icon style="font-size: 18px; color: green" v-if="item.auth_required && freshTokenRetrievalTransactionCompleted && authData">mdi-lock-open</v-icon>
                    </span>
                </template>

            </v-data-table>

            <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>

            <!-- STATS TAB -->
            <h3 class="mb-10 diia-h3-header" ref="detail_stats">Статистика</h3>

            <v-data-table
                dense
                locale="uk-UA"
                :headers="stats_headers"
                :items="stats_data"
                disable-pagination
                disable-sort
                disable-filtering
                hide-default-footer
                hide-default-header
                :loading="stats_loading"
                mobile-breakpoint="1"
                class="elevation-0 pa-0 data-table-detail-design fifty-table"
            ></v-data-table>

            <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>

            <!-- DOCUMENTATION TAB -->
            <template v-if="show_detail_intf">
                <h3 class="mb-10 diia-h3-header" ref="detail_docs">Документація</h3>
                <v-data-table
                    dense
                    locale="uk-UA"
                    :headers="documentation_headers"
                    :items="documentation_data"
                    disable-pagination
                    disable-sort
                    disable-filtering
                    hide-default-footer
                    hide-default-header
                    :loading="documentation_loading"
                    :no-data-text="($config.configuration.information_resource_interface.detail.restrictions.documentation.auth_required && !authData) ? 'Необхідна авторизація' : 'Документація відсутня'"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-design-documentation"
                >
                <template v-slot:item.document="{ item }">
                    <a href="#" @click.prevent="downloadFile(item.document, true, 'documentation')" :style="isFileDownloading(item.document, 'documentation') ? 'pointer-events: none; opacity: 0.7;' : ''" class="view-href-a">{{ isFileDownloading(item.document, 'documentation') ? 'Завантаження...' : 'Завантажити' }}</a>
                </template>
                
                </v-data-table>
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </template>

            <!-- INFO SYSTEMS -->
            <template v-if="show_detail_org">
                <h3 class="mb-10 diia-h3-header" ref="detail_irs">Інформаційні е-ресурси</h3>
                <v-data-table
                    dense
                    locale="uk-UA"
                    :hide-default-footer="information_resources_data.length == 0"
                    :hide-default-header="information_resources_data.length == 0"
                    :headers="information_resources_headers"
                    :items="information_resources_data"
                    @click:row="onClickDetailIrsSelect"
                    disable-pagination
                    disable-sort
                    disable-filtering
                    :loading="information_resources_list_loading"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </template>


            <!-- SUBSYSTEMS -->
            <template v-if="(show_detail_org && display_members_entities) || show_detail_irs || show_detail_server">
                <h3 class="mb-10 diia-h3-header" ref="detail_sub">Підсистеми</h3>
                <v-text-field
                    v-if="subsystems_data.length > 0"
                    v-model="subsystems_data_search"
                    label="Пошук підсистеми"
                    append-icon="mdi-magnify"
                    class="ma-0 pa-0 v-colored-search"
                ></v-text-field>
                <v-data-table
                    :search="subsystems_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="subsystems_data.length == 0"
                    :hide-default-header="subsystems_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="subsystems_headers"
                    :items="subsystems_data"
                    @click:row="onClickDetailSubSelect"
                    :loading="subsystems_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </template>


            <!-- WEB-SERVICES -->
            <template v-if="(show_detail_org && display_members_entities) || show_detail_irs || show_detail_sub">
                <h3 class="mb-10 diia-h3-header" ref="detail_intf">Програмні інтерфейси е-ресурсів</h3>
                <v-text-field
                    v-if="interfaces_data.length > 0"
                    v-model="interfaces_data_search"
                    label="Пошук інтерфейсів інформаційного е-ресурсу"
                    append-icon="mdi-magnify"
                    class="ma-0 pa-0 v-colored-search"
                ></v-text-field>
                <v-data-table
                    :search="interfaces_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="interfaces_data.length == 0"
                    :hide-default-header="interfaces_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="interfaces_headers"
                    :items="interfaces_data"
                    @click:row="onClickDetailInterfaceSelect"
                    :loading="interfaces_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </template>


            <!-- SERVICES -->
            <template v-if="(show_detail_org && display_members_entities) || show_detail_irs || show_detail_sub || show_detail_intf || show_detail_server">
                <h3 class="mb-10 diia-h3-header" ref="detail_srv">Сервіси</h3>

                <v-text-field
                    v-if="services_data.length > 0"
                    v-model="services_data_search"
                    label="Пошук сервісів"
                    append-icon="mdi-magnify"
                    class="ma-0 pa-0 v-colored-search"
                ></v-text-field>

                <v-data-table
                    :search="services_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="services_data.length == 0"
                    :hide-default-header="services_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="services_headers"
                    :items="services_data"
                    @click:row="onClickDetailSrvSelect"
                    :loading="services_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </template>

            <!-- INTERACTIONS -->
            <template v-if="(show_detail_org && display_members_entities) || show_detail_irs || show_detail_sub || show_detail_intf">
                <h3 class="mb-10 diia-h3-header" ref="detail_itr">Взаємодії</h3>

                <v-text-field
                    v-if="services_data.length > 0"
                    v-model="interactions_data_search"
                    label="Пошук взаємодій"
                    append-icon="mdi-magnify"
                    class="ma-0 pa-0 v-colored-search"
                ></v-text-field>

                <v-data-table
                    :search="interactions_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="interactions_data.length == 0"
                    :hide-default-header="interactions_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="interactions_headers"
                    :items="interactions_data"
                    @click:row="onClickDetailItrSelect"
                    :loading="interactions_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
            </template>

            <!-- EXCHANGES -->
            <template v-if="show_detail_itr">
                <h3 class="mb-10 diia-h3-header" ref="detail_exc">Обміни</h3>

                <v-text-field
                    v-if="services_data.length > 0"
                    v-model="exchanges_data_search"
                    label="Пошук обмінів"
                    class="ma-0 pa-0 v-colored-search"
                    append-icon="mdi-magnify"
                ></v-text-field>

                <v-data-table
                    :search="exchanges_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="exchanges_data.length == 0"
                    :hide-default-header="exchanges_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="exchanges_headers"
                    :items="exchanges_data"
                    :loading="exchanges_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                ></v-data-table>
            </template>

            <!-- SERVER CERTIFICATES -->
            <template v-if="show_detail_server">
                <h3 class="mb-10 diia-h3-header" ref="detail_exc">Сертифікати ШБО</h3>

                <v-text-field
                    v-if="server_certificates_data.length > 0"
                    v-model="server_certificates_data_search"
                    label="Пошук сертифікатів"
                    class="ma-0 pa-0 v-colored-search"
                    append-icon="mdi-magnify"
                ></v-text-field>

                <v-data-table
                    :search="server_certificates_data_search"
                    dense
                    locale="uk-UA"
                    :hide-default-footer="server_certificates_data.length == 0"
                    :hide-default-header="server_certificates_data.length == 0"
                    :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                    :headers="server_certificates_headers"
                    :items="server_certificates_data"
                    :loading="server_certificates_list_loading"
                    :items-per-page="5"
                    no-data-text="Відсутні"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design"
                >
                <template v-slot:item.cert="{ item }">
                    <a href="#" @click.prevent="downloadFile(item.cert, true, 'certificate')" :style="isFileDownloading(item.cert, 'certificate') ? 'pointer-events: none; opacity: 0.7;' : ''" class="view-href-a">{{ isFileDownloading(item.cert, 'certificate') ? 'Завантаження...' : 'Завантажити' }}</a>
                </template>
                </v-data-table>
            </template>
        </v-col>
        <v-col cols="12" md="1" order="2" class="d-none d-md-block"></v-col>
        <v-col cols="12" md="3" order="1" order-sm="1" order-md="3">
            <div style="position: sticky; top: 20px;">
                <span class="mt-2" style="line-height: 1.2; font-size: 20px;">Навігація по сторінці</span>
                <v-divider style="background-color: black; border-width: 1px;" class="mt-5 mb-1"></v-divider>
                <v-list dense>
                    <v-list-item-group
                        v-model="selectedItem"
                        color="primary"
                    >
                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            @click="goto('detail_info')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Загальний опис
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            @click="goto('detail_stats')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Статистика
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="show_detail_intf"
                            @click="goto('detail_docs')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Документація
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="show_detail_org"
                            @click="goto('detail_irs')">

                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Інформаційні ресурси
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="(show_detail_org && display_members_entities) || show_detail_irs || show_detail_server"
                            @click="goto('detail_sub')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Підсистеми
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="(show_detail_org  && display_members_entities) || show_detail_irs || show_detail_sub"
                            @click="goto('detail_intf')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Інтерфейси е-ресурсів
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="(show_detail_org  && display_members_entities) || show_detail_irs || show_detail_sub || show_detail_intf || show_detail_server"
                            @click="goto('detail_srv')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Сервіси
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="(show_detail_org  && display_members_entities) || show_detail_irs || show_detail_sub || show_detail_intf"
                            @click="goto('detail_itr')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Взаємодії
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            class="pa-0 diia-side-nav-item" v-ripple="false"
                            v-if="show_detail_itr"
                            @click="goto('detail_exc')">
                            <v-list-item-content>
                                <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Обміни
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </div>
        </v-col>
    </v-row>
    </v-container>
</v-card>
    <v-snackbar
        v-model="downloadErrorSnackbar"
        color="error"
        :timeout="8000"
        top
        multi-line
        class="catalog-download-error-snackbar"
    >
        {{ downloadErrorMessage }}
        <template v-slot:action="{ attrs }">
            <v-btn
                icon
                x-small
                v-bind="attrs"
                class="catalog-download-error-close"
                aria-label="Закрити"
                @click="downloadErrorSnackbar = false"
            >
                <v-icon dense>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
    <v-snackbar
        v-model="serviceArchivedSnackbar"
        color="warning"
        :timeout="6000"
        top
        multi-line
        :class="['catalog-archive-snackbar', downloadErrorSnackbar ? 'catalog-archive-snackbar--below-error' : '']"
    >
        Цей сервіс перебуває в архіві. Завантажити WSDL не можна.
        <template v-slot:action="{ attrs }">
            <v-btn
                icon
                x-small
                v-bind="attrs"
                class="catalog-archive-snackbar-close"
                aria-label="Закрити"
                @click="serviceArchivedSnackbar = false"
            >
                <v-icon dense>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { mapState } from 'vuex';

export default {
  name: "CatalogItemDetailPage",
  data: () => ({
    breadcrumbs_navigation_items: [],

    detail_data_table_key: 54343832,

    detail_loading: false,
    stats_loading: false,
    documentation_loading: false,
    information_resources_list_loading: false,
    subsystems_list_loading: false,
    interfaces_list_loading: false,
    services_list_loading: false,
    interactions_list_loading: false,
    exchanges_list_loading: false,
    server_certificates_list_loading: false,

    show_tables: true,
    show_tables_org: true,
    show_tables_irs: false,
    show_tables_sub: false,
    show_tables_intf: false,
    show_tables_srv: false,
    show_tables_exch: false,

    display_members_entities: true,

    show_detail_org: true,
    show_detail_irs: false,
    show_detail_sub: false,
    show_detail_intf: false,
    show_detail_srv: false,
    show_detail_itr: false,
    show_detail_server: false,

    main_list_search: "",
    subsystems_data_search: "",
    interfaces_data_search: "",
    services_data_search: "",
    interactions_data_search: "",
    exchanges_data_search: "",
    server_certificates_data_search: "",

    detail_auth_data_response: {},
    detail_data_response: {},
    selectedItem: "",

    detail_headers: [
      {
        align: 'start',
        value: 'field',
        class: 'data-table-header fifty-width',
      },
      {
        align: 'start',
        value: 'value', 
        class: 'data-table-header fifty-width',
      },
    ],
    detail_data: [],
    detail_auth_data: [],

    stats_headers: [{
        align: 'start',
        value: 'field',
        class: 'data-table-header',
        width: "50%"
    }, { 
        align: 'start',
        value: 'value',
        class: 'data-table-header',
        width: "50%"
    }],
    stats_data: [],

    documentation_headers: [],
    documentation_data: [],

    information_resources_headers: [],
    information_resources_data: [],

    subsystems_headers: [],
    subsystems_data: [],

    interfaces_headers: [],
    interfaces_data: [],

    services_headers: [],
    services_data: [],

    interactions_headers: [],
    interactions_data: [],

    exchanges_headers: [],
    exchanges_data: [],

    server_certificates_headers: [],
    server_certificates_data: [],

    subscribed: false,
    banners_data: [],
    downloadingFiles: {},

    downloadErrorSnackbar: false,
    downloadErrorMessage: '',

    serviceArchivedSnackbar: false,
  }),
  created: function () {
    document.title = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : 'Каталог системи Трембіта';

    this.fetchServerData();
    this.setBreadcrumbsNavigation();
  },

  computed: {
    ...mapState(['authData', 'freshTokenRetrievalTransactionCompleted']),
  },

  watch: {
    freshTokenRetrievalTransactionCompleted() {
        if (this.$route.name == "server-detail-info") {
            if (this.authData) {
                this.fetchDetailServer(this.$config.configuration.server.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchSubsystems(this.$config.configuration.server.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), true);
                this.fetchServices(this.$config.configuration.server.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), true);
                this.fetchServerCertificates(this.$config.configuration.server.detail.endpoints.certificates.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                // this.fetchServerCertificates(this.$config.configuration.server.detail.endpoints.certificates.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
        }
        if (this.$route.name == 'organization-detail-info') {
            if (this.authData) {
                this.fetchDetailOrganizationSecureMetadata(this.$config.configuration.organization.detail.endpoints.secure_metadata.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
        }
        if (this.$route.name == 'interface-detail-info') {
            if (this.authData) {
                this.fetchAuthorizedDetailInterface(this.$config.configuration.information_resource_interface.detail.endpoints.authenticated_detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            } else {
                for (let item_id in this.$config.configuration.information_resource_interface.detail.items) {
                    let item = this.$config.configuration.information_resource_interface.detail.items[item_id];

                    if (item.auth_required) {
                        let foundIndex = this.detail_data.findIndex(x => x.code == item.code);
                        if (foundIndex != -1) {
                            this.detail_data[foundIndex].type = item.type;
                        }
                    }
                }
            }
        }
        if (this.$route.name == 'service-detail-info') {
            if (this.authData) {
                this.fetchAuthorizedDetailService(this.$config.configuration.service.detail.endpoints.authenticated_detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            } else {
                for (let item_id in this.$config.configuration.service.detail.items) {
                    let item = this.$config.configuration.service.detail.items[item_id];

                    if (item.auth_required) {
                        let foundIndex = this.detail_data.findIndex(x => x.code == item.code);
                        if (foundIndex != -1) {
                            this.detail_data[foundIndex].type = item.type;
                        }
                    }
                }
            }
        }
    },
      $route(to, from) {
        document.title = (to.meta && to.meta.title) ? to.meta.title : 'Каталог системи Трембіта';

        this.fetchServerData();
        this.setBreadcrumbsNavigation();
      }
  },
  
  methods: {
    

    async fetchServerData() {
        this.banners_data = [];
        this.serviceArchivedSnackbar = false;

        if (this.$route.name == 'organization-detail-info') {
            this.onClickMainOrganizationInit();

            this.information_resources_headers = this.$config.configuration.organization.detail.display.information_resources;
            this.subsystems_headers = this.$config.configuration.organization.detail.display.subsystems;
            this.interfaces_headers = this.$config.configuration.organization.detail.display.interfaces;
            this.services_headers = this.$config.configuration.organization.detail.display.services;
            this.interactions_headers = this.$config.configuration.organization.detail.display.interactions;

            this.fetchDetailOrganization(this.$config.configuration.organization.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchDetailOrganizationMetadata(this.$config.configuration.organization.detail.endpoints.metadata.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInformationResources(this.$config.configuration.organization.detail.endpoints.information_resources.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchSubsystems(this.$config.configuration.organization.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInterfaces(this.$config.configuration.organization.detail.endpoints.interfaces.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchServices(this.$config.configuration.organization.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInteractions(this.$config.configuration.organization.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
            if (this.authData && this.freshTokenRetrievalTransactionCompleted) {
                this.fetchDetailOrganizationSecureMetadata(this.$config.configuration.organization.detail.endpoints.secure_metadata.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
        }
        else if (this.$route.name == 'information-resource-detail-info') {
            this.onClickDetailIrsInit();

            this.subsystems_headers = this.$config.configuration.information_resource.detail.display.subsystems;
            this.interfaces_headers = this.$config.configuration.information_resource.detail.display.interfaces;
            this.services_headers = this.$config.configuration.information_resource.detail.display.services;
            this.interactions_headers = this.$config.configuration.information_resource.detail.display.interactions;

            this.fetchDetailInformationResource(this.$config.configuration.information_resource.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchSubsystems(this.$config.configuration.information_resource.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInterfaces(this.$config.configuration.information_resource.detail.endpoints.interfaces.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchServices(this.$config.configuration.information_resource.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInteractions(this.$config.configuration.information_resource.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
        }
        else if (this.$route.name == 'subsystem-detail-info') {
            this.onClickDetailSubInit();

            this.interfaces_headers = this.$config.configuration.subsystem.detail.display.interfaces;
            this.services_headers = this.$config.configuration.subsystem.detail.display.services;
            this.interactions_headers = this.$config.configuration.subsystem.detail.display.interactions;

            this.fetchDetailSubsystem(this.$config.configuration.subsystem.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInterfaces(this.$config.configuration.subsystem.detail.endpoints.interfaces.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchServices(this.$config.configuration.subsystem.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInteractions(this.$config.configuration.subsystem.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
        }
        else if (this.$route.name == 'interface-detail-info') {
            this.onClickDetailInterfaceInit();

            this.documentation_headers = this.$config.configuration.information_resource_interface.detail.display.documentation;
            this.services_headers = this.$config.configuration.information_resource_interface.detail.display.services;
            this.interactions_headers = this.$config.configuration.information_resource_interface.detail.display.interactions;

            this.fetchDocumentation(this.$config.configuration.information_resource_interface.detail.endpoints.documentation.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchServices(this.$config.configuration.information_resource_interface.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchInteractions(this.$config.configuration.information_resource_interface.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
        
            await this.fetchDetailInterface(this.$config.configuration.information_resource_interface.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
            if (this.authData && this.freshTokenRetrievalTransactionCompleted) {
                await this.fetchAuthorizedDetailInterface(this.$config.configuration.information_resource_interface.detail.endpoints.authenticated_detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            } else {
                for (let item_id in this.$config.configuration.information_resource_interface.detail.items) {
                    let item = this.$config.configuration.information_resource_interface.detail.items[item_id];

                    if (item.auth_required) {
                        let foundIndex = this.detail_data.findIndex(x => x.code == item.code);
                        if (foundIndex != -1) {
                            this.detail_data[foundIndex].type = item.type;
                        }
                    }
                }
            }
        }
        else if (this.$route.name == 'service-detail-info') {
            this.onClickDetailSrvInit();
            this.fetchStats(this.$config.configuration.service.detail.endpoints.stats.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), {
                "exchanges_good_total": "Всього успішних обмінів з початку роботи системи"
            });

            await this.fetchDetailService(this.$config.configuration.service.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
            if (this.authData && this.freshTokenRetrievalTransactionCompleted) {
                await this.fetchAuthorizedDetailService(this.$config.configuration.service.detail.endpoints.authenticated_detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
        }
        else if (this.$route.name == 'interaction-detail-info') {
            this.onClickDetailItrInit();

            this.exchanges_headers = this.$config.configuration.interaction.detail.display.exchanges;

            this.fetchDetailInteraction(this.$config.configuration.interaction.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            this.fetchExchanges(this.$config.configuration.interaction.detail.endpoints.exchanges.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
        }
        else if (this.$route.name == 'server-detail-info') {
            this.onClickDetailServerInit();

            this.server_headers = this.$config.configuration.server.detail.display.exchanges;
            this.subsystems_headers = this.$config.configuration.server.detail.display.subsystems;
            this.services_headers = this.$config.configuration.server.detail.display.services;
            this.server_certificates_headers = this.$config.configuration.server.detail.display.certificates;
            
            if (this.authData && this.freshTokenRetrievalTransactionCompleted) {
                this.fetchDetailServer(this.$config.configuration.server.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                // fetchDetailServerMetadata
                this.fetchSubsystems(this.$config.configuration.server.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), true);
                this.fetchServices(this.$config.configuration.server.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), true);
                this.fetchServerCertificates(this.$config.configuration.server.detail.endpoints.certificates.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
                // this.fetchServerCertificates(this.$config.configuration.server.detail.endpoints.certificates.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }// this.fetchExchanges(this.$config.configuration.interaction.detail.endpoints.exchanges.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
        }
    },

    switchEnv() {
        if (this.$config.query_params.env == 'SEVDEIR') {
            this.$config.query_params.env = 'SEVDEIR-TEST';
            this.$router.replace({name: this.$route.name, query: this.$config.query_params});
            this.$router.go();
        } else {
            this.$config.query_params.env = 'SEVDEIR';
            this.$router.replace({name: this.$route.name, query: this.$config.query_params});
            this.$router.go();
        }
    },

    subscribeToObject() {
        if (!this.subscribed) {
            this.axiosSecure({
                method: "post",
                url: this.$config.configuration.endpoints.subscribe.replace(':backend_url', this.$config.backend_url),
                data: {
                    'object_id': this.$route.params.id,
                    'object_type': '1'
                }
            })
            .then((response) => {
                this.subscribed = response.data;
            })
            .catch((error) => {
                // if (error.response.status == 404) {
                //     this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                // }
            })
            .finally(() => {
                // this.detail_loading = false;
            });
        } else {
            this.axiosSecure({
                method: "delete",
                url: this.$config.configuration.endpoints.unsubscribe.replace(':backend_url', this.$config.backend_url).replace(':id', this.subscribed),
            })
            .then((response) => {
                this.subscribed = "";
            })
            .catch((error) => {
                // if (error.response.status == 404) {
                //     this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                // }
            })
            .finally(() => {
                // this.detail_loading = false;
            });
        }
    },

    fetchDetailOrganization(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.detail_data = []
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.organization.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }

            if ((this.$config.query_params.env == 'SEVDEIR' && response.data.display_members_entities_prod) || (this.$config.query_params.env == 'SEVDEIR-TEST' && response.data.display_members_entities_test) ) {
                this.display_members_entities = true;
            } else {
                this.display_members_entities = false;
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },
    fetchDetailOrganizationMetadata(url) {
        // this.detail_loading = true;
        // this.detail_data_response = {};

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.banners_data = [];
            for (let item in response.data.banners) {
                this.banners_data.push(response.data.banners[item]);
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            // this.detail_loading = false;
        });
    },
    fetchDetailOrganizationSecureMetadata(url) {
        // this.detail_loading = true;
        // this.detail_data_response = {};

        this.axiosSecure({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.subscribed = response.data.meta.subscribed;
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            // this.detail_loading = false;
        });
    },
    fetchDetailInformationResource(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.detail_data = []
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.information_resource.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },

    fetchDetailSubsystem(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        axios({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_data = []
            this.detail_data_response = response.data;
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.subsystem.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },


    async fetchDetailInterface(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        return axios({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_data = [];
            this.detail_data_response = response.data;
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.information_resource_interface.detail.items, this.$config.query_params.env, true);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },

    async fetchAuthorizedDetailInterface(url) {
        this.detail_loading = true;
        this.detail_auth_data_response = {};

        return this.axiosSecure({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_auth_data = [];
            this.detail_auth_data_response = response.data;
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.information_resource_interface.detail.items, this.$config.query_params.env);

                let foundIndex = this.detail_data.findIndex(x => x.code == item);
                
                if (foundIndex != -1 && result) {
                    this.detail_data[foundIndex] = result;
                }
            }

            this.detail_data_table_key += 1;
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },


    async fetchDetailService(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        return axios({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_data_response = response.data;
            this.detail_data = []
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.service.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },

    async fetchAuthorizedDetailService(url) {
        this.detail_loading = true;
        this.detail_auth_data_response = {};

        return this.axiosSecure({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_auth_data = [];
            this.detail_auth_data_response = response.data;
            this.detail_data_response = { ...this.detail_data_response, ...response.data };
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.service.detail.items, this.$config.query_params.env);

                let foundIndex = this.detail_data.findIndex(x => x.code == item);
                
                if (foundIndex != -1 && result) {
                    this.detail_data[foundIndex] = result;
                }
            }

            this.detail_data_table_key += 1;
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },


    fetchDetailInteraction(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        axios({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_data = [];
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.interaction.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },

    fetchDetailServer(url) {
        this.detail_loading = true;
        this.detail_data_response = {};

        this.axiosSecure({
            method: "get",
            url: url
        })
        .then((response) => {
            this.detail_data = [];
            for (let item in response.data) {
                let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.server.detail.items, this.$config.query_params.env);

                if (result) {
                    this.detail_data.push(result);
                }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.detail_loading = false;
        });
    },

    fetchDetailServerMetadata(url) {
        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.banners_data = [];
            for (let item in response.data.banners) {
                this.banners_data.push(response.data.banners[item]);
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {});
    },

    fetchServerCertificates(url) {
        this.server_certificates_list_loading = true;

        this.axiosSecure({
            method: "get",
            url: url
        })
        .then((response) => {
            this.server_certificates_data = [];
            for (let item in response.data) {
                // let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.server.detail.display.certificates, this.$config.query_params.env);

                // console.log(result);

                if (this.$clib.isLessThan30DaysLeft(response.data[item].not_after))
                    this.banners_data.push({
                        "type": "warning",
                        "text" : "У сервера завершується термін дії сертифікату " + (response.data[item].type == "AUTH" ? "автентифікації" : "шифрування") + " через " + this.$clib.time_difference_days(response.data[item].not_after) + ".",
                        "filter_type": "certificates",
                        "key": this.$clib.uuidv4()
                    })
                
                else if (!this.$clib.isExpirationDateValid(response.data[item].not_after))
                    this.banners_data.push({
                        "type": "error",
                        "text" : "У сервера завершився термін дії сертифікату " + (response.data[item].type == "AUTH" ? "автентифікації." : "шифрування."),
                        "filter_type": "certificates",
                        "key": this.$clib.uuidv4()
                    })

                // if (result) {
                response.data[item].not_after = this.$clib.dateFormatToUkrainian(response.data[item].not_after);
                
                this.server_certificates_data.push(response.data[item]);
                // }
            }
        })
        .catch((error) => {
            if (error.response.status == 404) {
                this.$router.replace({ name: 'notFound', query: this.$config.query_params });
            }
        })
        .finally(() => {
            this.server_certificates_list_loading = false;
        });
    },



    fetchDocumentation(url) {
        this.documentation_loading = true;

        this.axiosSecure({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.documentation_data = []
            for (let item in response.data) {
                response.data[item].updated_at = this.$clib.dateFormatToUkrainian(response.data[item].updated_at);
                this.documentation_data.push(response.data[item]);
            }
        })
        .catch((error) => {})
        .finally(() => {
            this.documentation_loading = false;
        });
    },

    fetchStats(url, translations) {
        this.stats_loading = true;

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.stats_data = [];
            for (let item in response.data) {
                let field = "";
                let value = response.data[item];

                if (item in translations) {
                    field = translations[item];
                }
                
                if (item != "id")
                    this.stats_data.push({
                        "field": field,
                        "value": value,
                    })
            }
        })
        .catch((error) => {})
        .finally(() => {
            this.stats_loading = false;
        });
    },







    fetchInformationResources(url) {
        this.information_resources_list_loading = true;

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.information_resources_data = [];

            for (let item in response.data) {
                this.information_resources_data.push(response.data[item]);
            }

            this.stats_data.push({
                field: "Зареєстрованих інформаційних е-ресурсів",
                value: this.information_resources_data.length,
            });
        })
        .catch((error) => {})
        .finally(() => {
            this.information_resources_list_loading = false;
        });
    },
    fetchSubsystems(url, secured=false) {
        this.subsystems_list_loading = true;

        if (!secured) {
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.subsystems_data = [];

                console.log(this.subsystems_data);

                for (let item in response.data) {
                    this.subsystems_data.push(response.data[item]);
                }

                this.stats_data.push({
                    field: "Зареєстрованих підсистем",
                    value: this.subsystems_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.subsystems_list_loading = false;
            });
        } else {
            this.axiosSecure({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.subsystems_data = [];

                console.log(this.subsystems_data);

                for (let item in response.data) {
                    this.subsystems_data.push(response.data[item]);
                }

                this.stats_data.push({
                    field: "Зареєстрованих підсистем",
                    value: this.subsystems_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.subsystems_list_loading = false;
            });
        }
    },
    fetchInterfaces(url) {
        this.interfaces_list_loading = true;

        axios({
            method: "get",
            url: url,
        })
        .then((response) => {
            this.interfaces_data = []

            for (let item in response.data) {
                this.interfaces_data.push(response.data[item]);
            }

            this.stats_data.push({
                field: "Зареєстрованих інтерфейсів е-ресурсу",
                value: this.interfaces_data.length
            });
        })
        .catch((error) => {})
        .finally(() => {
            this.interfaces_list_loading = false;
        });
    },
    fetchServices(url, secured=false) {
        this.services_list_loading = true;

        if (!secured) {
            console.log("HEHRE");
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.services_data = []

                for (let item in response.data) {
                    this.services_data.push(response.data[item]);
                }

                this.stats_data.push({
                    field: "Опублікованих сервісів",
                    value: this.services_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.services_list_loading = false;
            });
        } else {
            this.axiosSecure({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.services_data = []

                for (let item in response.data) {
                    this.services_data.push(response.data[item]);
                }

                this.stats_data.push({
                    field: "Опублікованих сервісів",
                    value: this.services_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.services_list_loading = false;
            });
        }
    },


    fetchInteractions(url) {
        this.interactions_list_loading = true;

        axios({
            method: "get",
            url: url,
            params: {
                instance: this.$config.query_params.env
            }
        })
        .then((response) => {
            this.interactions_data = []

            for (let item in response.data) {
                this.interactions_data.push(response.data[item]);
            }

            this.stats_data.push({
                field: "Зареєстрованих взаємодій",
                value: this.interactions_data.length
            });
        })
        .catch((error) => {})
        .finally(() => {
            this.interactions_list_loading = false;
        });
    },


    fetchExchanges(url) {
        this.exchanges_list_loading = true;

        axios({
            method: "get",
            url: url,
            params: {
                instance: this.$config.query_params.env
            }
        })
        .then((response) => {
            this.exchanges_data = [];

            for (let item in response.data) {
                this.exchanges_data.push(response.data[item]);
            }

            this.stats_data.push({
                field: "Складових обмінів",
                value: this.exchanges_data.length
            });
        })
        .catch((error) => {})
        .finally(() => {
            this.exchanges_list_loading = false;
        });
    },

    setBreadcrumbsNavigation() {
        const env_text = this.$route.query.env == 'SEVDEIR' ? '(пром)' : '(тест)';

        if (this.$route.name == 'organization-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Організації ' + env_text,
                    disabled: false,
                    href: "/catalog/organizations/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про організацію',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'information-resource-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Е-ресурси ' + env_text,
                    disabled: false,
                    href: "/catalog/information_resources/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про е-ресурс',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'subsystem-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Підсистеми ' + env_text,
                    disabled: false,
                    href: "/catalog/subsystems/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про підсистему',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'interface-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Інтерфейси е-ресурсів ' + env_text,
                    disabled: false,
                    href: "/catalog/interfaces/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про інтерфейс е-ресурсу',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'service-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Сервіси ' + env_text,
                    disabled: false,
                    href: "/catalog/services/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про сервіс',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'interaction-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Взаємодії ' + env_text,
                    disabled: false,
                    href: "/catalog/interactions/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про взаємодію',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
        else if (this.$route.name == 'server-detail-info') {
            this.breadcrumbs_navigation_items = [
                {
                    text: 'Каталог',
                    disabled: false,
                    href: '/',
                },
                {
                    text: 'Шлюзи безпечного обміну ' + env_text,
                    disabled: false,
                    href: "/catalog/servers/?env=" + this.$route.query.env,
                },
                {
                    text: 'Про шлюз безпечного обміну',
                    disabled: false,
                    href: this.$route.path + "?env=" + this.$route.query.env,
                },
            ]
        }
    },



    clearTablesData() {
        this.detail_data = []
        this.stats_data = []
        this.documentation_data = []
        this.information_resources_data = []
        this.subsystems_data = []
        this.interfaces_data = []
        this.services_data = []
        this.interactions_data = []
    },



    onSearchEnter(val) {
        this.$config.query_params = this.$clib.clearQueryParams(this.$config.query_params)

        if (val == "org") {
            this.$config.query_params.search_org = this.main_list_search;
            this.$router.push({ name: 'organizations-list', query: this.$config.query_params });
        }
        if (val == "irs") {
            this.$config.query_params.search_irs = this.main_list_search;
            this.$router.push({ name: 'information-resources-list', query: this.$config.query_params });
        }
        if (val == "sub") {
            this.$config.query_params.search_sub = this.main_list_search;
            this.$router.push({ name: 'subsystems-list', query: this.$config.query_params });
        }
        if (val == "intf") {
            this.$config.query_params.search_intf = this.main_list_search;
            this.$router.push({ name: 'interfaces-list', query: this.$config.query_params });
        }
        if (val == "srv") {
            this.$config.query_params.search_srv = this.main_list_search;
            this.$router.push({ name: 'services-list', query: this.$config.query_params });
        }
        if (val == "itr") {
            this.$config.query_params.search_itr = this.main_list_search;
            this.$router.push({ name: 'interactions-list', query: this.$config.query_params });
        }
    },

    onClickDetailItem(value) {
        if (value.id) {
            if (value.route_type == 'org')
                this.onClickMainOrganizationSelect(value)
            if (value.route_type == 'irs')
                this.onClickDetailIrsSelect(value)
            if (value.route_type == 'sub')
                this.onClickDetailSubSelect(value)
            if (value.route_type == 'intf')
                this.onClickDetailInterfaceSelect(value)
        }
    },

    onClickTabOrganization(value) {
      this.show_tables = true;
      this.show_tables_org = false;
      this.show_tables_irs = false;
      this.show_tables_sub = false;
      this.show_tables_intf = false;
      this.show_tables_srv = false;

      if (value == 'org')
        this.show_tables_org = true;
      else if (value == 'irs')
        this.show_tables_irs = true;
      else if (value == 'sub')
        this.show_tables_sub = true;
      else if (value == 'intf')
        this.show_tables_intf = true;
      else if (value == 'srv')
        this.show_tables_srv = true;
    },
    onClickAnalytics(value) {
        this.$router.push({ name: 'organization-analytics-info', params: { id: this.$route.params.id }, query: this.$config.query_params });
    },
    onAnalyticsDetailedFilter(filter_type) {
        this.$router.push({ name: 'organization-analytics-info', params: { id: this.$route.params.id }, query: {"details_type_filter": filter_type, ...this.$config.query_params }});
    },
    onClickMainOrganizationSelect(value) {
        this.$router.push({ name: 'organization-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickMainOrganizationInit();
    },
    onClickMainOrganizationInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = true;
      this.show_detail_irs = false;
      this.show_detail_sub = false;
      this.show_detail_intf = false;
      this.show_detail_srv = false;
      this.show_detail_itr = false;
      this.show_detail_server = false;

      this.clearTablesData();
    },
    onClickDetailIrsSelect(value) {
        this.$router.push({ name: 'information-resource-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickDetailIrsInit();
    },
    onClickDetailIrsInit(value) {
        window.scrollTo(0, 0);

        this.show_tables = false;
        this.show_detail_org = false;
        this.show_detail_irs = true;
        this.show_detail_sub = false;
        this.show_detail_intf = false;
        this.show_detail_srv = false;
        this.show_detail_itr = false;
        this.show_detail_server = false;

        this.clearTablesData();
    },
    onClickDetailSubSelect(value) {
        this.$router.push({ name: 'subsystem-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickDetailSubInit();
    },
    onClickDetailSubInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = false;
      this.show_detail_irs = false;
      this.show_detail_sub = true;
      this.show_detail_intf = false;
      this.show_detail_srv = false;
      this.show_detail_itr = false;
      this.show_detail_server = false;

      this.clearTablesData();
    },
    onClickDetailInterfaceSelect(value) {
        this.$router.push({ name: 'interface-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickDetailInterfaceInit();
    },
    onClickDetailInterfaceInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = false;
      this.show_detail_irs = false;
      this.show_detail_sub = false;
      this.show_detail_intf = true;
      this.show_detail_srv = false;
      this.show_detail_itr = false;
      this.show_detail_server = false;

      this.clearTablesData();
    },
    onClickDetailSrvSelect(value) {
        this.$router.push({ name: 'service-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickDetailSrvInit();
    },
    onClickDetailSrvInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = false;
      this.show_detail_irs = false;
      this.show_detail_sub = false;
      this.show_detail_intf = false;
      this.show_detail_srv = true;
      this.show_detail_itr = false;
      this.show_detail_server = false;

      this.clearTablesData();
    },
    onClickDetailItrSelect(value) {
        this.$router.push({ name: 'interaction-detail-info', params: { id: value.id }, query: this.$config.query_params });
        this.onClickDetailItrInit();
    },
    onClickDetailItrInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = false;
      this.show_detail_irs = false;
      this.show_detail_sub = false;
      this.show_detail_intf = false;
      this.show_detail_srv = false;
      this.show_detail_itr = true;
      this.show_detail_server = false;

      this.clearTablesData();
    },
    onClickDetailServerInit(value) {
      window.scrollTo(0, 0);

      this.show_tables = false;
      this.show_detail_org = false;
      this.show_detail_irs = false;
      this.show_detail_sub = false;
      this.show_detail_intf = false;
      this.show_detail_srv = false;
      this.show_detail_itr = false;
      this.show_detail_server = true;

      this.clearTablesData();
    },

    goto(refName) {
      var element = this.$refs[refName];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },

    getDownloadName(headers, filePath) {
        const contentDisposition = headers && (headers['content-disposition'] || headers['Content-Disposition']);
        if (contentDisposition) {
            const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
            if (utfMatch && utfMatch[1]) {
                return decodeURIComponent(utfMatch[1]);
            }

            const plainMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
            if (plainMatch && plainMatch[1]) {
                return plainMatch[1];
            }
        }

        const parts = (filePath || '').split('/');
        return parts[parts.length - 1] || 'download';
    },

    sanitizeFileName(name) {
        if (!name) {
            return '';
        }

        return name
            .replace(/[\\/:*?"<>|]/g, '_')
            .replace(/\s+/g, ' ')
            .trim();
    },

    getDownloadStateKey(filePath, itemCode='') {
        return `${itemCode || 'file'}::${filePath || ''}`;
    },

    isFileDownloading(filePath, itemCode='') {
        const key = this.getDownloadStateKey(filePath, itemCode);
        return !!this.downloadingFiles[key];
    },

    isServiceArchivedPayload(data) {
        if (!data || typeof data !== 'object') {
            return false;
        }
        const v = data.is_deleted;
        if (v === true || v === 1) {
            return true;
        }
        if (typeof v === 'string') {
            const s = v.trim().toLowerCase();
            if (s.includes('архів')) {
                return true;
            }
            if (s === 'true' || s === '1' || s === 'yes') {
                return true;
            }
        }
        return false;
    },

    async formatDownloadError(error, itemCode='') {
        if (itemCode === 'current_wsdl_link') {
            return 'Не вдалося завантажити файл. ШБО на якому знаходиться сервіс не доступне. Спробуйте пізніше.';
        }

        const status = error.response && error.response.status;
        const data = error.response && error.response.data;

        if (data instanceof Blob) {
            const type = (data.type || '').toLowerCase();
            if (type.includes('json') || type.includes('text')) {
                try {
                    const text = await data.text();
                    const json = JSON.parse(text);
                    const detail = json.detail || json.message || json.error;
                    if (detail && typeof detail === 'string') {
                        return status
                            ? `Не вдалося завантажити файл (код ${status}): ${detail}`
                            : `Не вдалося завантажити файл: ${detail}`;
                    }
                } catch (e) {
                    /* fall through */
                }
            }
        } else if (data && typeof data === 'object' && !(data instanceof Blob)) {
            const detail = data.detail || data.message || data.error;
            if (detail && typeof detail === 'string') {
                return status
                    ? `Не вдалося завантажити файл (код ${status}): ${detail}`
                    : `Не вдалося завантажити файл: ${detail}`;
            }
        }

        if (status) {
            return `Не вдалося завантажити файл (код ${status}). Спробуйте пізніше.`;
        }
        return 'Не вдалося завантажити файл. Перевірте з’єднання та спробуйте пізніше.';
    },

    async downloadFile(filePath, authRequired=false, itemCode='') {
        if (!filePath) {
            return;
        }

        if (itemCode === 'current_wsdl_link' && this.isServiceArchivedPayload(this.detail_data_response)) {
            this.serviceArchivedSnackbar = true;
            return;
        }

        const url = filePath.startsWith('http') ? filePath : `${this.$config.backend_url}${filePath}`;
        const requester = authRequired ? this.axiosSecure : axios;
        const key = this.getDownloadStateKey(filePath, itemCode);
        this.$set(this.downloadingFiles, key, true);

        try {
            const response = await requester({
                method: "get",
                url: url,
                responseType: "blob",
            });

            const blobUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobUrl;
            if (itemCode == 'current_wsdl_link') {
                const serviceCode = this.sanitizeFileName(this.detail_data_response.service_code) || 'service';
                link.download = `${serviceCode}.wsdl`;
            } else {
                link.download = this.getDownloadName(response.headers, filePath);
            }
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error('downloadFile', error);
            this.downloadErrorMessage = await this.formatDownloadError(error, itemCode);
            this.downloadErrorSnackbar = true;
        } finally {
            this.$delete(this.downloadingFiles, key);
        }
    },
  }
}
</script>